// ApexFooter.js
import React from 'react';
import './ApexFooter.css';
import { FaDiscord, FaYoutube } from 'react-icons/fa';
import { BsClipboard2CheckFill } from 'react-icons/bs';
import { MdOutlineVideoLibrary } from 'react-icons/md';
import paypalImg from '../rust/assets/paypal.png';
import visaImg from '../rust/assets/visa.png';
import mastercardImg from '../rust/assets/mastercard.png';
import aliplayImg from '../rust/assets/alipay.png';
import bitcoinImg from '../rust/assets/bitcoin.png';
import etherImg from '../rust/assets/ether.png';
import skinsImg from '../rust/assets/skins.png';
import giftcardsImg from '../rust/assets/giftcards.png';
import tetherImg from '../rust/assets/tether.png';
import webmoneyImg from '../rust/assets/webmoney.png';
import unionpayImg from '../rust/assets/unionpay.png';
import eagleLogo from './assets/eagle_apex_logo.png';
import { useTranslation } from 'react-i18next';

const ApexFooter = React.memo(() => {
  const { t } = useTranslation();
  return (
    <footer className="apex-footer">
      {/* Animated pulsating line */}
      <div className="apex-footer-line"></div>
      <div className="apex-footer__inner">
        {/* Logo ganz links und verlinkt */}
        <div className="apex-footer__section apex-footer__section--left">
          <a href="https://eaglescript.space/" className="apex-footer__logo-link">
            <img 
              src={eagleLogo} 
              alt="EAGLE SCRIPT Logo - Best Apex Legends No Recoil Script" 
              className="apex-footer__logo" 
              loading="lazy"
            />
          </a>
        </div>

        {/* Second Column: Useful Links */}
        <div className="apex-footer__section apex-footer__section--left">
          <h3>{t('footer_useful_links')}</h3>
          <p>
            <a
              href="https://www.youtube.com/watch?v=t4YOfdqBrhs"
              target="_blank"
              rel="noopener noreferrer"
              className="apex-footer__link"
            >
              <MdOutlineVideoLibrary className="apex-footer__icon" /> {t('footer_how_to_setup')}
            </a>
          </p>
          <p>
            <a
              href="#Tos"
              target="_blank"
              rel="noopener noreferrer"
              className="apex-footer__link"
            >
              <BsClipboard2CheckFill className="apex-footer__icon" /> {t('footer_terms_of_service')}
            </a>
          </p>
        </div>

        {/* Third Column: Pay With */}
        <div className="apex-footer__section apex-footer__section--left">
          <h3>{t('footer_pay_with')}</h3>
          <div className="apex-footer__grid">
            {[paypalImg, visaImg, mastercardImg, aliplayImg, bitcoinImg, etherImg, skinsImg, giftcardsImg, tetherImg, webmoneyImg, unionpayImg].map((src, i) => (
              <div key={i} className="apex-footer__grid-item">
                <img src={src} alt={`Payment method ${i + 1} - Secure payment option`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        {/* Fourth Column: Find Us On */}
        <div className="apex-footer__section apex-footer__section--left">
          <h3>{t('footer_find_us_on')}</h3>
          <div className="apex-footer__contacts">
            <p>
              <a
                href="https://discord.com/invite/zEeq3jTzAR"
                target="_blank"
                rel="noopener noreferrer"
                className="apex-footer__link"
              >
                <FaDiscord className="apex-footer__icon" /> {t('footer_discord')}
              </a>
            </p>
            <p>
              <a
                href="https://www.youtube.com/@EAGLESCRIPT"
                target="_blank"
                rel="noopener noreferrer"
                className="apex-footer__link"
              >
                <FaYoutube className="apex-footer__icon" /> {t('footer_youtube')}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="apex-footer__copyright">
        {t('footer_copyright')}
      </div>
    </footer>
  );
});

export default ApexFooter;